module.exports = __webpack_public_path__ + "img/cbiaLogo.4c7ff076.png";